<ng-container
  *ngIf="
    (authSandbox.isLoading$ | async) === false || isErrorPageRoute;
    else spinner
  "
>
  <lnch-portal-launcher
    [showLauncher]="!isErrorPageRoute"
    [showMainLogo]="false"
    [showSideMenu]="authSandbox.authenticated$ | async"
    (themeChange)="themeChange($event)"
  ></lnch-portal-launcher>
  <div class="fullscreen" *ngIf="(isThemeChanged$ | async) || isErrorPageRoute">
    <app-header
      *ngIf="!isErrorPageRoute"
      [isAuthenticated]="authSandbox.authenticated$ | async"
      [username]="(appFacade.userProfile$ | async)?.userName"
      [profilePhoto]="appFacade.profilePhoto$ | async"
      [myprofileURI]="appFacade.myprofileURI$ | async"
    ></app-header>

    <div class="page-content">
      <router-outlet></router-outlet>
    </div>

    <app-footer
      *ngIf="!isErrorPageRoute"
      (login)="authSandbox.login()"
      [isLoggedIn]="authSandbox.authenticated$ | async"
    ></app-footer>
  </div>
</ng-container>

<ng-template #spinner>
  <hohr-loading-screen></hohr-loading-screen>
</ng-template>
